const ALL = ["List", "Get", "Create", "Update", "Delete", "Subscribe"] as const;

const s = (
    service: string,
    ...methods: ((typeof ALL)[number] | "all" | string)[]
) => {
    const finalMethods = methods[0] === "all" ? ALL : methods;

    return finalMethods.map((method) => `${service}Service.${method}`);
};

const ACCESS = {
    dashboard: [],
    adminTime: [
        ...s("Time", "all"),
        ...s("CalendarExternal", "List", "Get", "Subscribe"),
        ...s("TimeContract", "List", "Get"),
        ...s("Track", "List", "Get"),
        ...s("TrackGroup", "List", "Get"),
        ...s("Calendar", "List", "Get", "Set"),
        ...s("TimeRelation", "Get", "GetCalendarEvent"),
        ...s("Project", "List", "Get"),
        ...s("Feecode", "List", "Get"),
    ],
    adminApproval: [
        [...s("ApproveExpense", "List"), ...s("ApproveInvoice", "List")],
    ],
    adminExpenses: [
        ...s("Expense", "List", "Get", "Subscribe"),
        ...s("ExpenseType", "List", "Get"),
    ],
    adminTasks: [
        ...s("Task", "List", "Get"),
        ...s("TaskAssignment", "List", "Get"),
        ...s("TaskUser", "List", "Get", "Subscribe"),
    ],
    projects: [
        ...s("Project", "List", "Get"),
        ...s("Task", "List", "Get"),
        ...s("TaskAssignment", "List", "Get"),
        ...s("Budget", "List", "Get"),
        ...s("BudgetLine", "CreateA", "CreateI", "CreateO"),
        ...s("BudgetPhase", "Create"),
    ],
    project: [
        ...s("Project", "List", "Get"),
        ...s("Task", "List", "Get"),
        ...s("TaskAssignment", "List", "Get"),
        ...s("Budget", "List", "Get"),
        ...s("BudgetLine", "CreateA", "CreateI", "CreateO"),
        ...s("BudgetPhase", "Create"),
    ],
    projectBudget: [
        ...s("Budget", "List", "Get", "Open"),
        ...s("BudgetLine", "CreateA", "CreateI", "CreateO"),
        ...s("BudgetPhase", "Create"),
    ],
    projectTasks: [
        ...s("Task", "List", "Get"),
        ...s("TaskAssignment", "List", "Get"),
    ],
    projectPurchase: [
        ...s("Purchasecode", "List", "Get"),
        ...s("PurchaseOrderLine", "CreateItem", "CreateText"),
    ],
    projectInvoicing: [
        ...s("ProInvoiceText", "List", "Get"),
        ...s("ProInvoiceTextRow", "Create", "Delete"),
    ],
    projectDocuments: ["not_implemented"],
    resources: [
        ...s("Task", "List", "Get", "Subscribe"),
        ...s("TaskAssignment", "all"),
        ...s("TaskUser", "List", "Get", "Subscribe"),
        ...s("TimeContract", "List", "Get", "Subscribe"),
        ...s("CalendarExternal", "List", "Get", "Subscribe"),
        ...s("CalendarExtEvent", "List", "Get", "Subscribe"),
    ],
    chat: ["not_implemented"],
    settings: ["hidden_for_now"],
    help: [],
    profile: [
        ...s("TrackGroup", "all"),
        ...s("Project", "List", "Get"),
        ...s("Feecode", "List", "Get"),
    ],
} as const;

export default ACCESS;
